import { render } from "./DatasetTile.vue?vue&type=template&id=5bd4d5f7&scoped=true"
import script from "./DatasetTile.vue?vue&type=script&lang=js"
export * from "./DatasetTile.vue?vue&type=script&lang=js"

import "./DatasetTile.vue?vue&type=style&index=0&id=5bd4d5f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd4d5f7"]])

export default __exports__